import { Component, inject, model, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import {
  WorkDocument,
  WorkDocumentsV2Service,
  WorkDocumenttypeIdentifierNameEnum,
  WorkProject,
} from '@work-frontend-monorepo/work-rest-api';
import { ExceptionHandlingService } from '@work-frontend-monorepo/work-ui/services';
import { TableBaseClass } from '@work-frontend-monorepo/work-ui/tables';
import { GalleryComponent } from '@work-frontend-monorepo/work-ui/rich-content';

@Component({
  selector: 'sfg-app-projekte-fotos',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule, GalleryComponent],
  templateUrl: './projekte-fotos.component.html',
  styleUrl: './projekte-fotos.component.scss',
})
export class ProjekteFotosComponent extends TableBaseClass<WorkDocument> implements OnInit {
  public project = model.required<WorkProject>();
  private readonly documentsV2Service = inject(WorkDocumentsV2Service);
  private readonly exceptionHandlingService = inject(ExceptionHandlingService);

  async ngOnInit() {
    await this.load();
  }

  public override async load() {
    try {
      this.dataPaginated = await lastValueFrom(
        this.documentsV2Service.documentsV2ControllerFindAllPaginated({
          limit: 50,
          page: this.getPage(),
          sortBy: this.getSortBy(),
          'filter.projectId': [`${this.project().id}`],
          'filter.documenttype.identifierName': [`$eq:${WorkDocumenttypeIdentifierNameEnum.Projektfoto}`],
        }),
      );
    } catch (documentLoadException) {
      this.exceptionHandlingService.handleExceptionWithAlert('documentLoadException', documentLoadException);
    }
  }

  protected readonly WorkDocumenttypeIdentifierNameEnum = WorkDocumenttypeIdentifierNameEnum;
}
